module.exports = __webpack_public_path__ + "../static/img/geladeira.a7fbb776.png";